import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
import { QualifierValue } from "../../internal/qualifier/QualifierValue.js";
/**
 * @description Represents a layer in a Photoshop document.
 * </br><b>Learn more:</b> {@link https://cloudinary.com/documentation/paged_and_layered_media#deliver_selected_layers_of_a_psd_image|Deliver selected layers of a PSD image}
 * @extends SDK.Action
 * @memberOf Actions.PSDTools
 * @see Visit {@link Actions.PSDTools| PSDTools} for an example
 */

var GetLayerAction = /*#__PURE__*/function (_Action) {
  _inherits(GetLayerAction, _Action);

  var _super = _createSuper(GetLayerAction);

  function GetLayerAction() {
    var _this;

    _classCallCheck(this, GetLayerAction);

    _this = _super.call(this);
    _this.qualifierValue = new QualifierValue();
    _this.qualifierValue.delimiter = ';';
    return _this;
  }
  /**
   * @description deliver an image containing only specified layer of a Photoshop image from The layer index
   * @param {string|number} from the index of the layer
   */


  _createClass(GetLayerAction, [{
    key: "byIndex",
    value: function byIndex(from) {
      this.qualifierValue.addValue(from);
      return this;
    }
    /**
     * @description deliver an image containing only specified range of layers of a Photoshop image
     * @param {string|number} from The layer number
     * @param {string|number} to The layer number
     */

  }, {
    key: "byRange",
    value: function byRange(from, to) {
      var range = new QualifierValue(from);
      range.addValue(to);
      range.delimiter = '-';
      this.qualifierValue.addValue(range);
      return this;
    }
    /**
     * @description deliver an image containing only specified layer by name of a Photoshop image
     * @param {string|number} name The layer by name
     */

  }, {
    key: "byName",
    value: function byName(name) {
      this.name = name;
      this.qualifierValue.addValue(name);
      return this;
    }
  }, {
    key: "prepareQualifiers",
    value: function prepareQualifiers() {
      var qualifierValue = this.qualifierValue;

      if (this.name) {
        qualifierValue = new QualifierValue(['name', this.qualifierValue]).setDelimiter(':');
      }

      this.addQualifier(new Qualifier('pg', qualifierValue));
      return this;
    }
  }]);

  return GetLayerAction;
}(Action);

export { GetLayerAction };